<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioActividad" name="nomFormularioActividad">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'PRODUCTOACTIVIDAD.LBL_SEGMENTO' | translate }}</label>
          <div *ngIf="!proActividad">
            <p-dropdown disableTab  id="idSegmento" name="nomSegmento" [options]="lisSegmentos" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idSegmento"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idSegmento.invalid">
              {{ 'PRODUCTOACTIVIDAD.LBL_SEGMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <label *ngIf="proActividad && proActividad.idProductoSegmento"
                 class="falso-combo-texto">{{proActividad.nombreSegmento}}</label>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12" formArrayName="campos">
        <p-fieldset legend="{{ 'PRODUCTOACTIVIDAD.LBL_CAMPOSFORMULARIO' | translate }}">
          <div *ngFor="let campo of campos.controls; let i=index">
            <div class="grid" *ngIf="i%3===0">
              <ng-container *ngFor="let iteracion of iterador; let ite=index">
                <div class="col-4 md:col-4 lg:col-4" *ngIf="campos.controls.length > (i + ite)" [formGroupName]="i + ite">
                  <p-checkbox label="{{ campos.controls[i + ite].controls.nombreCampo.value }}"
                              formControlName="indicadorHabilitado"
                              binary="true"></p-checkbox>
                </div>
              </ng-container>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>


    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>


  </form>
</div>

<p-confirmDialog #cd key="actividad-editar">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
